import UploadIcon from '@mui/icons-material/Upload';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fab from '@mui/material/Fab';

interface FloatingActionButtonProps {
    label: string;
    loading: boolean;
    disable: boolean;
    onClick: () => void;
}

export function FloatingActionButton({ label, loading, disable, onClick }: FloatingActionButtonProps) {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 40,
                right: 40,
            }}
        >
            <Fab color='primary' variant='extended' onClick={onClick} disabled={disable}>
                {loading ? (
                    <>
                        <CircularProgress />
                        {label}
                    </>
                ) : (
                    <>
                        {disable ? (
                            <>Will be enabled shortly.</>
                        ) : (
                            <>
                                <UploadIcon />
                                {label}
                            </>
                        )}
                    </>
                )}
            </Fab>
        </Box>
    );
}
